import { memo } from 'preact/compat'
import { getStylesFn } from 'core/helpers/styles'
import { ElementTimerOptions } from 'core/types/element/element_timer'

const extractStyles = getStylesFn(
  [
    'color',
    'lineHeight',
    'textTransform',
    'textDecoration',
    'letterSpacing',
    'textShadow',
    'fontFamily',
    'fontSize',
    'fontWeight'
  ],
  {
    flex: 1
  }
)

type Props = {
  options: ElementTimerOptions
  value: string
  label: string
}

const TimerBox = (props: Props) => {
  const labelStyles = extractStyles(props.options.label)
  const valueStyles = {
    ...extractStyles(props.options.value),
    fontVariantNumeric: 'tabular-nums'
  }

  return (
    <div style={{ flex: 1 }} className="wf_reset">
      <div style={valueStyles} className="wf_reset">
        {props.value}
      </div>
      <div style={labelStyles} className="wf_reset">
        {props.label}
      </div>
    </div>
  )
}

export default memo(TimerBox)
